import { Container, Grid, Paper, TablePagination, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { errorMessage } from '../../../util/ConfirmAlertUtil';
import { page } from './api-mural-usuario';
import TablePaginationActions from '../../../shared/components/Table/Actions';
import Loading from '../../UI/Loading';
import MuralCardV2 from '../MuralCardV2';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    paper: {
        // display: 'flex',
        // flexDirection: 'column',
    },
    title: {
        // flex: '1 1 100%',
        // marginBottom: '20px',
        // marginTop: '20px'
    },
})

const MuralUsuarioContainer = () => {
    const classes = useStyles();
    const [pageMuralUsuario, setPageMuralUsuario] = useState({
        content: [],
        size: 0,
        number: 0,
        totalPages: 0
    })
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchMuralUsuario(0);
    }, []);

    const handleChangePage = (event, newPage) => {
        fetchMuralUsuario(newPage);
    }

    const fetchMuralUsuario = (newPage) => {
        setIsLoading(true);
        page(newPage).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setPageMuralUsuario(data);
                }
            }
            setIsLoading(false);
        })
    }

    return (
        <>
            <Grid container spacing={3}>
                <Grid size={12}>
                    <Typography className={classes.title} variant="h5">
                        Mural de Fotos
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <Container className={classes.paper} component={Paper}>
                        <Grid container spacing={3}>
                            {isLoading ?
                                <Grid size={12}>
                                    <Loading style={{ marginTop: '20px' }} description='Carregando Mural de Fotos' />
                                </Grid>
                                :
                                <>
                                    {pageMuralUsuario.content.length > 0 ?
                                        <>
                                            {pageMuralUsuario.content.map(muralUsuario => (
                                                <Grid key={muralUsuario.codigo}>
                                                    <MuralCardV2
                                                        mural={muralUsuario.mural}
                                                    />
                                                </Grid>

                                            ))}
                                        </>
                                        : <p>Nenhum Mural Cadastrado.</p>
                                    }
                                </>}
                            <Grid size={12}>
                                <TablePagination
                                    rowsPerPageOptions={[]}
                                    rowsPerPage={pageMuralUsuario.size ? pageMuralUsuario.size : 0}
                                    component="div"
                                    count={pageMuralUsuario.totalElements}
                                    page={pageMuralUsuario.number}
                                    onPageChange={handleChangePage}
                                    labelDisplayedRows={({ from, to, count }) => (from + "-" + (to ? to : '1') + " de " + (count ? (count !== -1 ? count + " registros" : + " mais de " + to) : '1'))}
                                    slots={{
                                        actions: TablePaginationActions
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Container>
                </Grid>
            </Grid>
        </>
    );
}

export default MuralUsuarioContainer;